import React from 'react';
import clsx from 'clsx';

import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Tooltip from '@material-ui/core/Tooltip';
import { UPLOAD_OPTIONS } from '@shared/constants';

import useStyle from './style';
const defaultProps = {
  bgcolor: 'background.paper',
  borderColor: 'grey.500',
  border: 1,
  style: { width: '2rem', height: '2rem' },
};
const SuccessList = ({
  action = UPLOAD_OPTIONS.CREATE_OR_UPDATE_RULE,
  successList = [],
  countData = [],
}) => {
  const classes = useStyle();
  return (
    <div className='mt-2'>
      <Typography
        variant='body2'
        className={clsx('text-bold', classes.successColorText)}
      >
        {`Succesfully ${
          action === UPLOAD_OPTIONS.DELETE_RULE ? 'deleted' : 'updated'
        }:`}
      </Typography>
      <div className='d-flex f-align-center'>
        {!!successList.length && (
          <Typography variant='body2' className='align-left color-success mt-2'>
            {successList.join(', ')}
          </Typography>
        )}
        {!!successList.length && !!countData.length && (
          <Tooltip
            title={'Extension IDs: ' + countData.join(', ')}
            placement='top-start'
          >
            <Box borderRadius='50%' {...defaultProps} className='ml-2 mt-2'>
              <Typography
                variant='body1'
                className='color-text-secondary d-flex f-justify-center mt-1'
              >
                +{countData.length}
              </Typography>
            </Box>
          </Tooltip>
        )}
        {!successList.length && !!countData.length && (
          <Typography variant='body2' className='align-left color-success mt-2'>
            Extension IDs: {countData.join(', ')}
          </Typography>
        )}
      </div>
    </div>
  );
};
export default SuccessList;
